// here you find constants used in both front end and back end code
// for front end only constants look in client/src/constants.js
// for back  end only constants look in services/constants.js

export const INSIGHTS_TAB = 'Insights';
export const REPORTS_TAB = 'Reports';

// export const ANALYTICS_EVENT_TYPE = 'dash.analyticsEvent';
// export const FEEDBACK_EVENT_ORIGIN = 'coursewareFrontend';

export const MAX_MOBILE_WIDTH = 709;
// export const COURSE_TYPE_SECTION_MANAGER = 'section_manager';
// export const COURSE_TYPE_SECTION = 'section';

// export const PRODUCT_MODELS = Object.freeze({
//   readandpractice: 1,
//   skills: 2,
//   quantitative: 3,
//   qualitative: 4,
//   essentials: 5,
//   goreact: 6,
//   'ccw-pages': 7,
// });

// export const QQ_SUPPORTED_PRODUCT_MODELS = [
//   PRODUCT_MODELS.quantitative,
//   PRODUCT_MODELS.qualitative,
//   PRODUCT_MODELS.goreact,
//   PRODUCT_MODELS.essentials,
// ];

// export const VIEW_RELATION_TYPES = Object.freeze({
//   RESOURCES_VIEW_ID: 1,
//   COURSE_PLANNER_VIEW_ID: 2,
//   READING_VIEW_ID: 3,
//   CUSTOM_CONTENT_VIEW_ID: 4,
// });
